<template>
  <section id="loading-screen">
    <div class="wrapper">
      <div class="loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
  @import "./loader.scss";
</style>
